import { useTranslation } from 'react-i18next';
import {
  type ResetUserPasswordMutationError,
  useResetUserPassword,
} from '@/entities/tenantusers/api/generated/api';
import { toast } from '@/shared/ui';

export const useResetPasswordMutation = ({ onSuccess }: { onSuccess: () => void }) => {
  const { t } = useTranslation();
  const userTitle = t('user-management.navigation.title');

  return useResetUserPassword({
    request: { suppressToast: true },
    mutation: {
      onSuccess: () => {
        toast.success(t('user-management.users.reset-password.success'));
        onSuccess();
      },
      onError: (_error: ResetUserPasswordMutationError) => {
        toast.error(t('common.messages.update-failed', { name: userTitle }));
      },
    },
  });
};
